import {ButtonGroup, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {ReactNode} from 'react';

export interface PepYesNoFieldProps {
  label: ReactNode;
  tooltip?: ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
}

/** Label + divided yes/no toggle shared by `PepToggleField` (the top-level PEP question) and `PepPartyFields` (the "still in role" question) — both draw their yes/no copy from the same `pep.toggleYes`/`toggleNo` keys. */
export function PepYesNoField({label, tooltip, value, onChange}: PepYesNoFieldProps) {
  const {t} = useTranslation('trustAccounts');
  const p = `activation.packages.trustDetails.form.fields.pep` as const;

  const items = [
    {value: 'yes', label: t(`${p}.toggleYes`)},
    {value: 'no', label: t(`${p}.toggleNo`)}
  ];

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <Typography size="sm" weight="medium" className="whitespace-normal">
          {label}
        </Typography>
        {tooltip}
      </div>
      <div className="w-48">
        <ButtonGroup
          variant="divided"
          value={value ? 'yes' : 'no'}
          onChange={v => onChange(v === 'yes')}
          items={items}
        />
      </div>
    </div>
  );
}
